export class Data<T extends Data<T>>{
    constructor(model?: T) {
        Object.assign(this, model);
    }
}

